import { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { t } from "@lingui/core/macro";
import { AlertMessage } from "../api/types";

interface AlertSnackbarProps {
    alertMessage: AlertMessage | undefined;
    updateAlertStatus: (
        alertMessage: AlertMessage | undefined
    ) => void;
    duration?: number;
}

const AlertSnackbar = ({ alertMessage, updateAlertStatus, duration = 6000 }: AlertSnackbarProps) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (alertMessage && alertMessage.message) {
            setOpen(true);
        }
    }, [alertMessage]);

    const handleClose = (
        event?: React.SyntheticEvent | Event,
        reason?: string
    ) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
        updateAlertStatus(undefined);
    };

    return (
        alertMessage?.severity === "none" ? null : (
            <Snackbar
                open={open}
                autoHideDuration={duration}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert
                    onClose={handleClose}
                    severity={alertMessage?.severity}
                    sx={{ width: "100%" }}
                >
                    {alertMessage?.message || t`Something went wrong. Please try again later.`}
                </Alert>
            </Snackbar>
        )
    );
};

export default AlertSnackbar;
